// extracted by mini-css-extract-plugin
module.exports = {"containerAfp":"RetiroAfp_containerAfp__BVOuK","mainAfpContainer":"RetiroAfp_mainAfpContainer__1hiQO"};